'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _ContactsPlaceholder = require('./ContactsPlaceholder.scss');var styles = _interopRequireWildcard(_ContactsPlaceholder);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ContactsPlaceholder = function ContactsPlaceholder() {var _cx;var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},className = _ref.className,isMobile = _ref.isMobile;return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.contactsPlaceholder, styles[className], (_cx = {}, _cx[styles.mobile] = isMobile, _cx)) },
      _react2.default.createElement('p', { className: styles.placeholderTitle }),
      _react2.default.createElement('p', { className: styles.placeholderRow }),
      _react2.default.createElement('p', { className: styles.placeholderRow }),
      isMobile ? _react2.default.createElement('p', { className: styles.placeholderRow }) : null));};exports.default =



ContactsPlaceholder;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/ContactsPlaceholder/ContactsPlaceholder.js
// module id = 2788
// module chunks = 0